import * as React from "react";
import { useInitializeOfflineData, useToast } from "duck";
import { useUpdateAnestheticProtocolMutation } from "requests";
import { SelectionContext } from "../../../../../../../duck";

export const useRename = (onClose: () => void) => {
  const toast = useToast();
  const { selected, setSelected } = React.useContext(SelectionContext);
  const selectedProtocol = selected[0];
  const [update] = useUpdateAnestheticProtocolMutation({ ignoreResults: true });
  const { loadProtocols } = useInitializeOfflineData();

  const onSuccess = () => {
    toast({
      status: "success",
      description: "Anesthetic Protocol is updated successfully."
    });
    setSelected([]);
    onClose();
  };

  return {
    onSubmit: (values: { name: string }) =>
      update({
        variables: { input: { _id: selectedProtocol._id, name: values.name } }
      }).then(() => {
        onSuccess();
        loadProtocols();
      }),
    initialName: selectedProtocol.name
  };
};
